import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.label,
      item: item.href || undefined,
    })),
  };

  return (
    <nav aria-label="面包屑导航" className="w-full px-4 md:px-6">
      <div className="max-w-[1400px] mx-auto pt-20 pb-2">
        <ol className="flex items-center gap-1.5 text-xs text-foreground-500">
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
          />
          {items.map((item, index) => (
            <li key={index} className="flex items-center gap-1.5">
              {index > 0 && (
                <i className="ri-arrow-right-s-line text-xs text-foreground-600"></i>
              )}
              {item.href ? (
                <Link
                  to={item.href}
                  className="hover:text-primary-400 transition-colors"
                >
                  {item.label}
                </Link>
              ) : (
                <span className="text-foreground-300">{item.label}</span>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
}